import styled, { css } from "styled-components";
export const Flex = styled.div `
  ${({ alignItems = "center", alignSelf, justifySelf, justifyContent = "start", gap = 0, direction = "row", wrap = "nowrap", grow, inline = false }) => css `
    display: ${inline ? "inline-" : ""}flex;
    position: relative;
    flex-wrap: ${wrap};
    align-items: ${alignItems};
    justify-content: ${justifyContent};
    gap: ${typeof gap === "number" ? `${gap}px` : gap};
    flex-direction: ${direction};
    ${grow === undefined ? "" : `flex-grow: ${grow};`}
    ${alignSelf === undefined ? "" : `align-self: ${alignSelf};`}
    ${justifySelf === undefined ? "" : `justify-self: ${justifySelf};`}
  `}
`;
